import { useCallback, useRef, useState } from "react";

// Share the lock between saving and closing so an older save cannot race closure.
export function useEncounterSave() {
  const pending = useRef(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const runSave = useCallback(async (operation) => {
    if (pending.current) return false;
    pending.current = true;
    setSaving(true);
    setSaveError("");
    try {
      await operation();
      return true;
    } catch (error) {
      // Do not expose raw transport errors or clinical payloads in logs/UI.
      if(error?.response?.status===422 && typeof error.response.data?.detail==="string") { setSaveError(error.response.data.detail); return false; }
      setSaveError("Changes could not be saved. Keep this page open and try saving again. If your session is locked, sign in first.");
      return false;
    } finally {
      pending.current = false;
      setSaving(false);
    }
  }, []);

  return { runSave, saving, saveError };
}
